// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

/*
  Please note magic webpack comments. The value of the commented keys should match the name and key of the object
  containing the magic comment. If we do not do this, our CSS for the page will load late and cause CLS spikes.
  See following for example.

  landingA: {
    name: 'landingA',
    chunk: () => import(
      \/*webpackChunckName: "landingA"*\/   <---- mandatory magic webpack comment
    )
  }
*/
export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  landingA: {
    name: 'landingA',
    componentName: 'LandingPage',
    chunk: () => import(
      /* webpackChunkName: "landingA" */
      './pages/LandingPage'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/LandingPage.js')).LandingPage
        : currentRouteName === 'landingA'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.LandingPage })));
    },
    path: '/:context?/:contentPV?/a/:slug/:guid?',
    channel: null,
    varnish: true
  },
  landingB: {
    name: 'landingB',
    componentName: 'LandingPage',
    chunk: () => import(
      /* webpackChunkName: "landingB" */
      './pages/LandingPage'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/LandingPage.js')).LandingPage
        : currentRouteName === 'landingB'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.LandingPage })));
    },
    path: '/:context?/:contentPV?/b/:slug1?/:slug2?/:guid',
    channel: null,
    varnish: true
  },
  landingC: {
    name: 'landingC',
    componentName: 'LandingPage',
    chunk: () => import(
      /* webpackChunkName: "landingC" */
      './pages/LandingPage'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/LandingPage.js')).LandingPage
        : currentRouteName === 'landingC'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.LandingPage })));
    },
    path: '/:context?/:contentPV?/c/:slug/:guid?',
    channel: null,
    varnish: true
  },
  landingTest: {
    name: 'landingTest',
    componentName: 'LayoutPreview',
    chunk: () => import(
      /* webpackChunkName: "landingTest" */
      './pages/LayoutPreview'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/LayoutPreview.js')).LayoutPreview
        : currentRouteName === 'landingTest'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.LayoutPreview })));
    },
    path: '/:context?/:contentPV?/landingPagePV/:LayoutTypeID/:LayoutId?/:TestPageId?',
    channel: null,
    varnish: true
  }
  // home: {
  //   name: 'home',
  //   componentName: 'Home',
  //   chunk: () => import(
  //     /* webpackChunkName: "home" */
  //     './pages/Home'
  //   ),
  //   get component() {
  //     return ssr
  //       ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
  //       : currentRouteName === 'home'
  //         ? currentRouteComponent
  //         : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
  //   },
  //   path: '/:context?/',
  //   channel: null
  // },
});
